import { defineStore } from 'pinia'
import { consola } from 'consola'
import type { GetReferralCodeResponseDto, ReferralStatsResponseDto } from './types'

const logger = consola.withTag('referral-store')

export const useReferralStore = defineStore('referral', () => {
  const referralCode = ref<GetReferralCodeResponseDto | null>(null)
  const stats = ref<ReferralStatsResponseDto | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)
  const hasInsufficientOrders = ref(false)

  const hasReferralCode = computed(() => !!referralCode.value?.code)
  const isReferralActive = computed(() => referralCode.value?.isActive === true)
  const canShowReferral = computed(() => {
    if (loading.value) return false
    if (hasInsufficientOrders.value) return false
    if (!referralCode.value && !stats.value) return false
    if (!isReferralActive.value) return false
    return true
  })
  const totalReferrals = computed(() => stats.value?.totalReferrals || 0)
  const totalPointsEarned = computed(() => stats.value?.totalPointsEarned || 0)
  const pendingPoints = computed(() => stats.value?.pendingPoints || 0)
  const activeReferrals = computed(() => stats.value?.activeReferrals || 0)
  const completedReferrals = computed(() => stats.value?.completedReferrals || 0)
  const promocode = computed(() => stats.value?.promocode || '')

  const setReferralCode = (data: GetReferralCodeResponseDto | null): void => {
    referralCode.value = data
  }
  const setStats = (data: ReferralStatsResponseDto | null): void => {
    stats.value = data
  }
  const setLoading = (value: boolean): void => { loading.value = value }
  const setError = (message: string | null): void => { error.value = message }
  const setInsufficientOrders = (value: boolean): void => { hasInsufficientOrders.value = value }
  const reset = (): void => {
    referralCode.value = null
    stats.value = null
    loading.value = false
    error.value = null
    hasInsufficientOrders.value = false
    logger.debug('Referral store reset')
  }

  return {
    referralCode: readonly(referralCode),
    stats: readonly(stats),
    loading: readonly(loading),
    error: readonly(error),
    hasInsufficientOrders: readonly(hasInsufficientOrders),
    hasReferralCode,
    isReferralActive,
    canShowReferral,
    totalReferrals,
    totalPointsEarned,
    pendingPoints,
    activeReferrals,
    completedReferrals,
    promocode,
    setReferralCode,
    setStats,
    setLoading,
    setError,
    setInsufficientOrders,
    reset,
  }
})
